/**
 * @generated SignedSource<<c81c5c7c2f6a6e927931dc04d26a1868>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoSectionSearchResultListVideoSectionSearchEdge$data = ReadonlyArray<{
  readonly node: {
    readonly content: {
      readonly __typename: "VideoSection";
      readonly entityId: string;
      readonly " $fragmentSpreads": FragmentRefs<"itemVideoSectionSearchResultListItemVideoSection">;
    } | null | undefined;
    readonly score: number | null | undefined;
  };
  readonly " $fragmentType": "videoSectionSearchResultListVideoSectionSearchEdge";
}>;
export type videoSectionSearchResultListVideoSectionSearchEdge$key = ReadonlyArray<{
  readonly " $data"?: videoSectionSearchResultListVideoSectionSearchEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoSectionSearchResultListVideoSectionSearchEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "videoSectionSearchResultListVideoSectionSearchEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoSectionSearchResultItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoSection",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "itemVideoSectionSearchResultListItemVideoSection"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VideoSectionSearchEdge",
  "abstractKey": null
};

(node as any).hash = "389512d1fa6ffb22b7968e283a6c4f11";

export default node;
